import React from "react";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import HeaderBox from "../../reuseableComponents/headerBox";
import IpsDeficienciesTable from "./IpsDeficienciesTable";
import PinToFavorites from "../../reuseableComponents/PinToFavorites";

const IpsDeficiencies = (props) => {
  return (
    <>
      <Row>
        <Col>
          <Link className='hyperlink' to='/' cypressid='backtoPublicLink'>
            Home
          </Link>
        </Col>
        <PinToFavorites reportId={166}></PinToFavorites>
      </Row>
      <Row>
        <Col>
          <HeaderBox id={"gray-primary"} cypressid='ipsDeficiencies'>
            <h3 style={{ color: "#fff" }}>IPS Deficiencies Report</h3>
          </HeaderBox>
        </Col>
      </Row>
      <Row>
        <Col>
          <IpsDeficienciesTable />
        </Col>
      </Row>
    </>
  );
};
export default IpsDeficiencies;
